import { Action, Dispatch } from "redux";
import { ActionTypes } from "./ActionTypes";
import { PortalState } from "../../types/PortalState";
import SurveyorCompletionStatus from "../../types/SurveyorCompletionStatus";
import { AssetType } from "../../types/AssetType";
import { postSurveyorData } from "../../services/UploadService";
import { toast } from "react-toastify";
import { Auth } from "aws-amplify";
import ReactGA from "react-ga4";

export const updateSurveyorCompletionStatus = (
    surveyorCompletionStatus: SurveyorCompletionStatus,
    type: AssetType,
    invalidElements: string[],
    invalidReUseSections : string[]
) => {
    return async (dispatch: Dispatch<Action>, getState: () => PortalState) => {

        const currentSession = await Auth.currentSession();
        const idToken = currentSession.getIdToken().getJwtToken();

        ReactGA.event({
            category: "Comment",
            action: "adding",
            label: type.toString(),
            value: 0
        });
        postSurveyorData(
            surveyorCompletionStatus,
            type,
            invalidElements,
            idToken,
            invalidReUseSections
        )
            .then(() => {
                ReactGA.event({
                    category: "Comment",
                    action: "added",
                    label: type.toString(),
                    value: 0
                });
                dispatch({
                    type: ActionTypes.UPDATE_COMPLETION_STATUS,
                    surveyorCompletionStatus: surveyorCompletionStatus
                });
            })
            .catch((error) => {
                toast.error(error);
                ReactGA.event({
                    category: "Comment",
                    action: "failed",
                    label: type.toString(),
                    value: 0
                });
            });
    };
};
